module.exports = __webpack_public_path__ + "static/media/logo-th.3cdcb503.png";